const toggleClassGroup = () => {
 const DATA_TARGET = `toggle-btn`;
 const DATA_TARGET_GROUP = `toggle-class-group`;
 const DATA_TOGGLE_CONTENT = `toggle-content`;

 const CLASS_ACTIVE = `active`;

 const getAriaAttrName = (target) => {
 const group = target.closest(`[data-${DATA_TARGET_GROUP}]`);

 return group?.matches(`[data-${DATA_TOGGLE_CONTENT}]`)
 ? `aria-expanded`
 : `aria-pressed`;
 };

 const getControlledElement = (element) => {
 const controlsId = element.getAttribute(`aria-controls`);

 if (controlsId) return document.getElementById(controlsId);

 return null;
 };

 const syncControlsTarget = (group) => {
 const targets = group.querySelectorAll(
 `[data-${DATA_TARGET}][aria-controls]`,
 );
 const ariaAttrName = getAriaAttrName(group);

 targets.forEach((target) => {
 if (target.closest(`[data-${DATA_TARGET_GROUP}]`) !== group) return;

 const controlledEl = getControlledElement(target);

 if (!controlledEl) return;

 controlledEl.setAttribute(
 `aria-hidden`,
 !target.matches(`[${ariaAttrName}="true"]`),
 );
 });
 };

 const setToggleGroup = () => {
 const targets = document.querySelectorAll(`[data-${DATA_TARGET}]`);
 const groups = document.querySelectorAll(`[data-${DATA_TARGET_GROUP}]`);

 targets.forEach((target) => {
 target.setAttribute(getAriaAttrName(target), `false`);

 if (target.matches(`a:not([role])`)) {
 target.setAttribute(`role`, `button`);

 if (target.matches(`a:not([data-origin-href])`)) {
 const originHref = target.getAttribute(`href`) ?? ``;
 const controlsId = target.getAttribute(`aria-controls`);

 target.setAttribute(`data-origin-href`, originHref);

 const newHref =
 originHref.startsWith(`#`) && originHref.length > 1
 ? originHref
 : controlsId
 ? `#${controlsId}`
 : `#`;

 target.setAttribute(`href`, newHref);
 }
 }
 });

 groups.forEach((group, idx) => {
 const groupValue =
 group.getAttribute(`data-${DATA_TARGET_GROUP}`) ||
 `group-idx-${idx + 1}`;
 const activeTarget = group.querySelector(
 `[data-${DATA_TARGET}].${CLASS_ACTIVE}`,
 );

 group.setAttribute(`data-${DATA_TARGET_GROUP}`, groupValue);
 activeTarget && updateState(activeTarget, groupValue);
 !activeTarget && syncControlsTarget(group);
 });
 };

 const updateState = (toggleTarget, groupValue) => {
 const ariaAttrName = getAriaAttrName(toggleTarget);

 document
 .querySelectorAll(`[data-${DATA_TARGET_GROUP}~="${groupValue}"]`)
 .forEach((group) => {
 const targets = group.querySelectorAll(`[data-${DATA_TARGET}]`);

 targets.forEach((target) => {
 if (target.closest(`[data-${DATA_TARGET_GROUP}]`) !== group) return;

 target.classList.remove(CLASS_ACTIVE);
 target.setAttribute(ariaAttrName, `false`);
 });
 });

 toggleTarget.classList.add(CLASS_ACTIVE);
 toggleTarget.setAttribute(ariaAttrName, `true`);

 syncControlsTarget(toggleTarget.closest(`[data-${DATA_TARGET_GROUP}]`));
 };

 const handleToggle = (event) => {
 const { target, key, type, repeat } = event;
 const toggleTarget = target.closest(`[data-${DATA_TARGET}]`);
 const targetGroup = toggleTarget?.closest(`[data-${DATA_TARGET_GROUP}]`);
 const ariaAttrName = toggleTarget
 ? getAriaAttrName(toggleTarget)
 : `aria-pressed`;
 const isActive = toggleTarget?.matches(`[${ariaAttrName}="true"]`);

 if (
 !toggleTarget ||
 !targetGroup ||
 (type !== `click` && type !== `keydown`) ||
 (type === `keydown` &&
 (repeat ||
 (key !== ` ` && key !== `Enter`) ||
 toggleTarget.matches(`button`)))
 )
 return;

 if (type === `keydown` && toggleTarget.matches(`a`)) {
 if (key === ` `) {
 event.preventDefault();
 toggleTarget.click();
 }

 return;
 }

 toggleTarget.matches(`a`) && event.preventDefault();

 if (isActive) return;

 updateState(
 toggleTarget,
 targetGroup.getAttribute(`data-${DATA_TARGET_GROUP}`),
 );
 };

 const initialize = () => {
 setToggleGroup();

 document.body.addEventListener(`click`, handleToggle);
 document.body.addEventListener(`keydown`, handleToggle);
 };

 initialize();

 toggleClassGroup.update = setToggleGroup;

 toggleClassGroup.cleanup = (targets) => {
 if (!targets) {
 document.body.removeEventListener(`click`, handleToggle);
 document.body.removeEventListener(`keydown`, handleToggle);

 return;
 }

 const toggleElements = document.querySelectorAll(`${targets}`);

 if (!toggleElements.length) return;

 toggleElements.forEach((element) => {
 element.matches(`a[aria-pressed][role], a[aria-expanded][role]`) &&
 element.removeAttribute(`role`);
 element.removeAttribute(`aria-pressed`);
 element.removeAttribute(`aria-expanded`);

 if (element.matches(`a[data-origin-href]`)) {
 element.setAttribute(`href`, element.getAttribute(`data-origin-href`));
 element.removeAttribute(`data-origin-href`);
 }
 });
 };
};

export default toggleClassGroup;
